<template>
  <multiselect v-model="rpoOrganization" :options="rpoOrganizations" label="name" :showLabels="false" track-by="cin" openDirection="bottom" :clear-on-select="false" :close-on-select="true" :searchable="true" @search-change="findOrganization" :loading="isLoading" :internal-search="false" placeholder="Názov alebo IČO" class="rpo-search" ref="rpoSelect">
    <template slot="singleLabel" slot-scope="props"><strong>{{ props.option.name}}</strong>&nbsp;(IČO: <b>{{ props.option.cin }}</b>) {{props.option.municipality}}</template>
    <template slot="option" slot-scope="props"><strong>{{ props.option.name}}</strong>&nbsp;{{ props.option.cin }} {{props.option.municipality}}<div><span class="text-bold text-red" v-if="props.option.terminated_on"> Zaniknutá: {{ props.option.terminated_on | filterDate }}</span>&nbsp;<span v-if="props.option.historicNames">Historické názvy: {{ props.option.historicNames }}</span></div></template>
  </multiselect>
</template>

<script>
const numberRegex = RegExp(/^[0-9]+/)

import debounce from 'lodash/debounce'
import Multiselect from 'vue-multiselect'
import { searchByTextCountry, searchByCinCountry } from '@/services/ElasticHttp'
export default {
  components: { Multiselect },
  props: {
    fetchedOrganization: Object
  },
  data () {
    return {
      rpoOrganization: null,
      rpoOrganizations: [],
      isLoading: false,
      forcedLastOption: null
    }
  },
  async created () {
    if (this.fetchedOrganization) {
      await this.findOrganizationByCin(this.fetchedOrganization.cin)
    }
  },
  methods: {
    onSearchTextChange: debounce(function (query) {
      if (query.length > 3) {
        this.findOrganization(query)
      } else {
        this.results = []
      }
    }, 350),
    async findOrganization (query) {
      if (!query.length) return
      if (query.length < 3) return
      this.isLoading = true
      const { data } = await this.$elasticHttp.post('prod_rpo_cz_sk_org_search', searchByTextCountry(query, 'sk'))
      // eslint-disable-next-line
      let requestList =  data.hits.hits.map(i => i._source)
      //preparelist
      this.rpoOrganizations = requestList.map(org => this.prepareOrg(org))
      if (numberRegex.test(query)) {
        this.rpoOrganizations.push({
          cin: query,
          name: 'Manuálne zadať IČO'
        })
      }
      if (this.forcedLastOption) {
        this.rpoOrganizations.push(this.forcedLastOption)
      }
      this.isLoading = false
    },
    prepareOrg (organization) {
      let historicNames = []
      // removed organizations
       if (organization.hasOwnProperty('names')) {
        historicNames = organization.names.filter(name => name == organization.name)
        organization.historicNames = historicNames.join(', ')
      }
      return organization
    },
    clearOptions: function () {
      this.rpoOrganizations = []
      this.rpoOrganization = null
    },
    async findOrganizationByCin(cin) {
      this.isLoading = true
      const { data } = await this.$elasticHttp.post('prod_rpo_cz_sk_org_search', searchByCinCountry(cin, 'sk'))
      // find one
      if (data.hits.total.value === 1) {
        let organization = data.hits.hits[0]._source
        this.rpoOrganization = this.prepareOrg(organization)
      } else {
        this.forcedLastOption = {
          cin: cin,
          name: 'Pôvodne zadaný vstup'
        }
        this.rpoOrganizations.push(this.forcedLastOption)
        this.rpoOrganization = this.forcedLastOption
      }
      this.isLoading = false
    }
  },
  watch: {
    rpoOrganization () {
      if (this.rpoOrganization === null) {
        this.$emit('input', {})
      } else {
        this.$emit('input', this.rpoOrganization)
      }
    }
  }
}
</script>

<style src="../../styles/vue-multiselect.min.css" lang="css" />
<style>
.text-red {
  color: red
}
.rpo-search .multiselect__select {
  display: none;
}

.field-invalid div.rpo-search div.multiselect__tags{
  border-color: Red !important;
}
</style>
